export default __webpack_public_path__ + "static/media/portfolioprojectWIP.0dec2717.PNG";